export interface ReactSelectItem {
  label: string;
  value: number;
}

export const stringsToReactSelectItems = (
  items: string[],
): ReactSelectItem[] => {
  return items.map((x, idx) => ({ label: x, value: idx }));
};
